export const getGroupLevelElectionsExcelData = (excelData) => {
  return [
    [],
    ["", "Interest Restriction Return Page 2"],
    [],
    ["", "Group level elections (full return)"],
    [],
    ["", "Fields below copy from p1"],
    excelData.gleRepComp,
    excelData.gleUltParent,
    [],
    excelData.gleEndPoA,
    [],
    [
      "",
      "Group level elections (Other than abbreviated return election)",
      "Enter E to elect",
      "Enter R to revoke",
    ],
    excelData.gleRow13,
    excelData.gleRow14,
    excelData.gleRow15,
    excelData.gleRow16,
    excelData.gleRow17,
    excelData.gleRow18,
    [],
    [],
    ["", "Group ratio blended election"],
    [
      "",
      "Enter below the investor group(s) to which election relates (enlarge box or insert rows if necessary)",
    ],
    excelData.gleRow23,
    [],
    ["", "Interest allowance (non-consolidated investment) election"],
    [
      "",
      "Enter below the non-consolidated investment(s) to which election relates (enlarge box or insert rows if necessary)",
    ],
    excelData.gleRow27,
    [],
    ["", "Interest allowance (consolidated partnerships) election "],
    [
      "",
      "Enter below partnership or partnerships to which election relates (including partnership UTR(s) where applicable), enlarge box or insert rows if necessary",
    ],
    excelData.gleRow31,
    [],
    ["", "Key"],
    ["", "Descriptive field or date", "Note"],
  ];
};
